// Define interfaces for error types
interface ErrorWithStatusCode {
  statusCode: number
}

interface ErrorWithStatus {
  status: number
}

interface ErrorWithDataStatusCode {
  data: {
    statusCode: number
  }
}

export async function withTokenRetry<T>(apiCall: () => Promise<T>): Promise<T> {
  const { refreshSession } = useAuthSession()

  try {
    // First attempt
    return await apiCall()
  }
  catch (error: unknown) {
    // Check if it's an authentication error - handle both types of error responses
    const isAuthError
      = (typeof error === 'object' && error !== null
        && (((error as ErrorWithStatusCode).statusCode === 401
          || (error as ErrorWithStatus).status === 401
          || ((error as ErrorWithDataStatusCode).data && (error as ErrorWithDataStatusCode).data.statusCode === 401))))

    if (isAuthError) {
      // Try to refresh the token
      const refreshed = await refreshSession()

      if (refreshed) {
        // Retry the API call with fresh token
        return await apiCall()
      }
      else {
        // If refresh fails, redirect to login
        navigateTo('/logout')
        throw new Error('Session expired, please log in again')
      }
    }

    // Not an auth error, rethrow
    throw error
  }
}
